import { parseUserAgent, browserName, browserVersion, fullBrowserVersion, osName, osVersion, isMobile, } from 'react-device-detect';
export function getBrowserInformation() {
    var _a, _b;
    var userAgent = navigator.userAgent;
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var screenColorDepth = window.screen.colorDepth;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var userLanguage = navigator.language;
    var cookieEnabled = navigator.cookieEnabled;
    var userAgentObject = parseUserAgent(userAgent);
    var cpuArchitecture = (_b = (_a = userAgentObject.cpu) === null || _a === void 0 ? void 0 : _a.architecture) !== null && _b !== void 0 ? _b : 'Unknown';
    return {
        userAgent: userAgent,
        browserName: browserName,
        majorVersion: parseInt(browserVersion),
        fullVersion: fullBrowserVersion,
        osName: osName,
        osVersion: osVersion,
        isMobile: isMobile,
        screenWidth: screenWidth,
        screenHeight: screenHeight,
        screenColorDepth: screenColorDepth,
        windowWidth: windowWidth,
        windowHeight: windowHeight,
        userLanguage: userLanguage,
        cookieEnabled: cookieEnabled,
        cpuArchitecture: cpuArchitecture,
    };
}
